import { Link } from "react-router-dom";
import { APP_NAME } from "@/lib/config";

export const LogoMark = ({ size = 34 }) => (
  <img src="/logo-mark.png" width={size} height={size} alt="" aria-hidden="true" className="rounded-[28%] object-cover" />
);

export const BrandLink = ({ to = "/" }) => (
  <Link to={to} data-testid="brand-home-link" className="flex items-center gap-2.5 group">
    <span className="transition-transform duration-300 group-hover:rotate-[-8deg] group-hover:scale-105">
      <LogoMark />
    </span>
    <span translate="no" className="notranslate font-display font-extrabold tracking-tight text-[17px] leading-none">{APP_NAME}</span>
  </Link>
);
